import { X } from 'lucide-react';

export type FilterBadgeVariant = 'date' | 'experience' | 'unit' | 'experienceTitle';

interface FilterBadgeProps {
  label: string;
  onRemove: () => void;
  variant: FilterBadgeVariant;
  maxWidth?: string;
}

const BADGE_VARIANTS: Record<FilterBadgeVariant, string> = {
  date: 'bg-blue-600/20 text-blue-200 border-blue-500/40 hover:bg-blue-600/30',
  experience: 'bg-orange-600/20 text-orange-200 border-orange-500/40 hover:bg-orange-600/30',
  unit: 'bg-green-600/20 text-green-200 border-green-500/40 hover:bg-green-600/30',
  experienceTitle: 'bg-purple-600/20 text-purple-200 border-purple-500/40 hover:bg-purple-600/30',
} as const;

const BUTTON_VARIANTS: Record<FilterBadgeVariant, string> = {
  date: 'text-blue-300 hover:text-blue-100 hover:bg-blue-600/50',
  experience: 'text-orange-300 hover:text-orange-100 hover:bg-orange-600/50',
  unit: 'text-green-300 hover:text-green-100 hover:bg-green-600/50',
  experienceTitle: 'text-purple-300 hover:text-purple-100 hover:bg-purple-600/50',
} as const;

export default function FilterBadge({
  label,
  onRemove,
  variant,
  maxWidth = 'max-w-[120px]',
}: FilterBadgeProps) {
  const badgeClasses = BADGE_VARIANTS[variant];
  const buttonClasses = BUTTON_VARIANTS[variant];

  return (
    <div
      className={`flex items-center gap-1 rounded border px-2 py-0.5 text-xs transition-colors ${badgeClasses}`}
    >
      <span className={`truncate ${maxWidth}`}>{label}</span>
      <button
        onClick={onRemove}
        className={`rounded p-0.5 transition-colors ${buttonClasses}`}
        aria-label={`Remove ${label} filter`}
      >
        <X size={12} />
      </button>
    </div>
  );
}
